import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { ClearDeviceCacheDocument } from './clear-cache.generated';

export const useClearDeviceCache = (options: ApiOptions<typeof ClearDeviceCacheDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(ClearDeviceCacheDocument, {
    ...useNotifications(ClearDeviceCacheDocument, {
      failure: t('api.common.error_generic'),
      success: () => t('api.devices.clear_cache_success'),
    }),
    ...options,
  });
};
